import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import {
    Insert as INSERT,
    SelectLoanType as SELECT_LOAN,
    SelectConsumerTypes as SELECT_CONSUMER
} from 'Components/Api/LeadGenerationMasterAPI';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    Container,
    Grid,
    MenuItem,
    Button,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MaterialDOBPickerField } from 'Components/Inputes/MaterialDOBPickerField';
import { LeadGenerationPopUP } from 'Components/Modal/LeadGenerationPopUP';
import { CustomModalWthText } from 'Components/Modal/CustomModalWthText';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { CONSUMER_LOAN, RETAILER_LOAN } from 'Components/Helper/OperatorCode';

import HOCLoader from 'Components/Loader/HOCLoader';
import Accordion from '@material-ui/core/Accordion';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { bgcolor } from '@material-ui/system';
const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const LeadGeneration = () => {
    const formRef = useRef();

    const [userTypeList, setUserTypeList] = useState([]);
    const [loadingOpen, setLoadingOpen] = React.useState(false);
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [openFilter, setOpenFilter] = useState(true);
    const [loan, setLoan] = useState([]);
    const [consumer, setConsumer] = useState([]);
    const [selectedLoan, setSelectedLoan] = useState('');
    const [firmName] = useState(localStorage.getItem('FirmName'));
    const [userID] = useState(localStorage.getItem('UserID'));
    const [isOpen, setIsOpen] = useState(false);
    const [Beneficiary, setBeneficiary] = useState({});

    const handleLoanChange = (event) => {
        setSelectedLoan(event.target.value);
    };

    const [formObj, setFormObj] = useState({
        FromDate: null,
        RetailerName: '',
        EmailID: '',
        MobileNumber: '',
        AadharNumber: '',
        PanNumber: '',
        RequiredAmount: '',
        ConsumerName: '',
        LoanTypeMasterID: 0,
        LoanType: '',
        ConsumerType: '',
        ConsumerTypeMasterID: 0,
        UserID: 0,
        MerchantName: '',
        agreeToTerms: false,
        Gender: ''
    });
    const OpenReportModalCallback = (value) => {
        setIsOpen(value);
    };

    const formValidationSchema = Yup.object({
        LoanTypeMasterID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'product type')
            .required(PLEASE_SELECT_VALID + 'product type'),

        ConsumerTypeMasterID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'employment type')
            .required(PLEASE_SELECT_VALID + 'employment type'),

        Gender: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'gender')
            .required(PLEASE_SELECT_VALID + 'gender'),

        ConsumerName: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'consumer name'
        ),

        MobileNumber: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'mobile number'
        ),

        EmailID: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile number'),

        AadharNumber: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'aadhar number'
        ),

        PanNumber: Yup.string().required(PLEASE_PROVIDE_VALID + 'pan number'),

        RequiredAmount: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'required amount'
        ),

        agreeToTerms: Yup.bool().oneOf(
            [true],
            'You must accept the terms and conditions'
        ),

        FromDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + ' from date')
            .required(PLEASE_SELECT_VALID + ' date')
            .max(new Date(), PLEASE_SELECT_VALID + ' from date')
            .typeError(PLEASE_SELECT_VALID + ' from date')
    });

    const reset = () => {
        setFormObj({
            FromDate: null,
            RetailerName: '',
            EmailID: '',
            MobileNumber: '',
            AadharNumber: '',
            PanNumber: '',
            RequiredAmount: '',
            ConsumerName: '',
            LoanTypeMasterID: 0,
            LoanType: '',
            ConsumerType: '',
            ConsumerTypeMasterID: 0,
            UserID: 0,
            MerchantName: '',
            agreeToTerms: false,
            Gender: ''
        });
    };

    const selectLoan = async () => {
        const response = await SELECT_LOAN();
        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setLoan(data);
    };

    const selectConsumer = async () => {
        const response = await SELECT_CONSUMER();
        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setConsumer(data);
    };

    useEffect(() => {
        selectLoan();
        selectConsumer();
    }, []);

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loadingOpen) return;
        var jsonReq = {
            RetailerName: firmName,
            ConsumerName: values.ConsumerName,
            MobileNumber: values.MobileNumber,
            AadharNumber: values.AadharNumber,
            PanNumber: values.PanNumber,
            RequiredAmount: values.RequiredAmount,
            EmailID: values.EmailID,
            LoanType: values.LoanTypeMasterID,
            ConsumerType: values.ConsumerTypeMasterID,
            UserID: userID,
            FromDate: values.FromDate,
            Gender: values.Gender
        };

        setIsError(false);
        var requestObj = JSON.stringify(jsonReq);
        setLoadingOpen(true);

        var response = await INSERT(requestObj);

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            return;
        }

        if (
            values.LoanTypeMasterID === CONSUMER_LOAN ||
            values.LoanTypeMasterID === RETAILER_LOAN
        ) {
            setIsOpen(true);
        }
        reset();
        resetForm();
    };

    const refreshForm = () => {
        if (!formRef.current) return;
        formRef.current.handleSubmit();
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={formValidationSchema}
                onSubmit={handleSubmit}
                resetForm={formObj}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form style={{ marginBottom: '15px' }}>
                            <Grid item xs={12}>
                                <CustomAccordion
                                    title={'Lead Generation'}
                                    open={openFilter}
                                    setOpen={(value) => setOpenFilter(value)}
                                >
                                    <Grid container spacing={3}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Retailer Name"
                                                name="RetailerName"
                                                value={firmName}
                                                type="text"
                                                placeholder="Retailer Name"
                                                readOnly={true}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Consumer Name"
                                                name="ConsumerName"
                                                type="text"
                                                placeholder="Consumer Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Mobile Number"
                                                name="MobileNumber"
                                                type="text"
                                                placeholder="Mobile Number"
                                                length={10}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="Gender"
                                                name="Gender"
                                                title="Select Gender"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Gender
                                                </MenuItem>
                                                <MenuItem
                                                    key={'Male'}
                                                    value={'Male'}
                                                >
                                                    {'Male'}
                                                </MenuItem>
                                                <MenuItem
                                                    key={'Female'}
                                                    value={'Female'}
                                                >
                                                    {'Female'}
                                                </MenuItem>
                                                <MenuItem
                                                    key={'Other'}
                                                    value={'Other'}
                                                >
                                                    {'Other'}
                                                </MenuItem>
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialDOBPickerField
                                                name="FromDate"
                                                label="Date Of Birth"
                                                maxDate={new Date()}
                                                value={values.FromDate}
                                                onChange={(value) =>
                                                    setFieldValue(
                                                        'FromDate',
                                                        value
                                                    )
                                                }
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Email ID"
                                                name="EmailID"
                                                type="text"
                                                placeholder="Email ID"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Aadhar Card"
                                                name="AadharNumber"
                                                type="text"
                                                placeholder="Aadhar Card"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Pan Card"
                                                name="PanNumber"
                                                type="text"
                                                placeholder="Pan Card"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Required Amount"
                                                name="RequiredAmount"
                                                type="text"
                                                placeholder="Required Amount"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="Select Product Type"
                                                name="LoanTypeMasterID"
                                                value={selectedLoan}
                                                onChange={handleLoanChange}
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Product Type
                                                </MenuItem>
                                                {loan.map((Item) => (
                                                    <MenuItem
                                                        key={
                                                            Item.LoanTypeMasterID
                                                        }
                                                        value={
                                                            Item.LoanTypeMasterID
                                                        }
                                                    >
                                                        {Item.LoanType}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="Select Employment Type"
                                                name="ConsumerTypeMasterID"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Employment Type
                                                </MenuItem>
                                                {consumer.map((Item) => (
                                                    <MenuItem
                                                        key={
                                                            Item.ConsumerTypeMasterID
                                                        }
                                                        value={
                                                            Item.ConsumerTypeMasterID
                                                        }
                                                    >
                                                        {Item.ConsumerType}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Field
                                                        as={Checkbox}
                                                        name="agreeToTerms"
                                                        color="primary"
                                                    />
                                                }
                                                label="I have read and agree to terms and conditions"
                                            />
                                            <ErrorMessage
                                                style={{
                                                    color: 'red'
                                                }}
                                                name="agreeToTerms"
                                                component="div"
                                                className="field-error-red"
                                            />
                                        </Grid>

                                        <Grid
                                            container
                                            spacing={2}
                                            style={{
                                                justifyContent: 'flex-end',
                                                display: 'flex'
                                            }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                style={{
                                                    justifyContent: 'flex-end',
                                                    display: 'flex'
                                                }}
                                            >
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    style={{
                                                        justifyContent: 'end',
                                                        marginBottom: '14px',
                                                        marginRight: '14px'
                                                    }}
                                                >
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={1}
                                                        lg={1}
                                                    >
                                                        <PrimaryButton
                                                            type="submit"
                                                            title="Submit"
                                                            className={
                                                                classes.CustomPrimaryButtonStyle
                                                            }
                                                            disabled={
                                                                loadingOpen
                                                            }
                                                        >
                                                            Submit
                                                        </PrimaryButton>
                                                        {loadingOpen && (
                                                            <CircularProgress
                                                                size={24}
                                                                className={
                                                                    classes.buttonProgress
                                                                }
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={1}
                                                        lg={1}
                                                    >
                                                        <SecondaryButton
                                                            type="reset"
                                                            variant="contained"
                                                            color="secondary"
                                                            title="Reset"
                                                            className={
                                                                classes.CustomDangerButtonStyle
                                                            }
                                                            onClick={() => {
                                                                reset();
                                                            }}
                                                        >
                                                            Reset
                                                        </SecondaryButton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CustomAccordion>
                            </Grid>
                        </Form>
                    );
                }}
            />
            {isOpen && (
                <CustomModalWthText
                    isOpen={isOpen}
                    title={`User Outstanding Report`}
                    width="50%"
                    onDismissCallback={OpenReportModalCallback}
                >
                    <LeadGenerationPopUP
                        onDismissCallback={OpenReportModalCallback}
                    />
                </CustomModalWthText>
            )}
        </CustomContainer>
    );
};
